import React, { JSX, useEffect } from "react";
import { FcGoogle } from "react-icons/fc";
import { UserAuth } from "../lib/authContext";
import { useNavigate } from "react-router-dom";
import logo from "../assets/images/logo.png";

const SignIn = () => {
  const navigate = useNavigate();
  const { googleSignIn, loading, user, userData } = UserAuth();

  useEffect(() => {
    if (loading) return; // Avoid running the effect while loading
    if (!user) {
      // If the user is not authenticated, stay on the sign-in page
      return;
    }

    navigate("/dashboard"); // Redirect to dashboard if user is authenticated
  }, [user, userData, loading, navigate]);

  return (
    <div className="flex flex-row min-h-screen w-full">
      <div className="hidden md:flex md:flex-col items-center justify-center w-1/2">
        <img
          src={logo}
          alt="ClientHub"
          className="max-h-80"
          onClick={() => navigate("/")}
        />
        <h5 className="text-5xl text-yellow-400 font-medium uppercase mt-10">
          ClientHub
        </h5>
      </div>
      <div className="flex flex-col items-center md:justify-center px-10 w-full md:w-1/2 bg-black">
        <img
          src={logo}
          alt="ClientHub"
          onClick={() => navigate("/")}
          className="md:hidden h-40 rounded-lg my-32"
        />
        <h4 className="mb-2.5 text-center text-white text-4xl font-bold">
          Sign In
        </h4>
        <button
          className="mb-6 mt-10 px-5 flex h-[50px] w-full md:max-w-96 items-center justify-center gap-2 rounded-xl bg-white hover:cursor-pointer"
          onClick={googleSignIn}
        >
          <div className="rounded-full text-xl">
            <span className="rounded-full text-xl">
              {FcGoogle({}) as JSX.Element}
            </span>
          </div>
          <h5 className="text-sm font-medium">Sign In with Google</h5>
        </button>
      </div>
    </div>
  );
};

export default SignIn;
